import { Navigate } from "react-router-dom";
import { isTokenExpired } from "../Services/tokenUtils";

/**
 * Wraps public-only routes (Login). If the user already has a valid session,
 * bounce them to /dashboard instead of showing the login form again —
 * prevents the "re-login as someone else on top of my own session" footgun
 * and removes the confusing "why am I on /login, I just logged in" state.
 */
export default function PublicRoute({ children }) {
  if (!isTokenExpired()) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
